// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-profile-view-image {
  display: inline-block;
  color: var(--fi-color-light);
  border-radius: 50%;
  width: 150px;
  height: 150px;
  position: relative;
}
.fi-profile-view-image .locked-profile {
  opacity: 0.5;
}
.fi-profile-view-image .profile-locked-icon {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  text-align: center;
  line-height: 130px;
  font-size: 70px;
  border-radius: 50%;
  border: 10px solid;
  opacity: 0.8;
}
.fi-profile-view-image .profile-locked-icon.square-icon {
  border-radius: 20px;
}
.fi-profile-view-image .profile-view-image {
  width: 150px;
  height: 150px;
  text-align: center;
  overflow: hidden;
  display: inline-block;
  position: relative;
  font-weight: 400;
  background: center center;
  background-size: cover;
  border-radius: 50%;
}
.fi-profile-view-image .profile-view-image span {
  display: block;
}
.fi-profile-view-image .profile-view-image .profile-icon {
  font-size: 150px;
  margin-top: 0;
  line-height: 1;
  height: 100%;
  overflow: hidden;
}
.fi-profile-view-image .profile-view-image .profile-icon.fi-icon-user-ico {
  font-family: "fontello";
}
.fi-profile-view-image.fi-profile-view-image-square {
  border-radius: 10px;
}
.fi-profile-view-image.fi-profile-view-image-square .profile-view-image {
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/profile-view/image/profile-view-image.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,4BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AACJ;AACI;EACI,YAAA;AACR;AAEI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAAR;AAEQ;EACI,mBAAA;AAAZ;AAII;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,cAAA;AAFZ;AAKQ;EACI,gBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAHZ;AAKY;EACI,uBAAA;AAHhB;AAQI;EACI,mBAAA;AANR;AAQQ;EACI,mBAAA;AANZ","sourcesContent":[".fi-profile-view-image {\r\n    display: inline-block;\r\n    color: var(--fi-color-light);\r\n    border-radius: 50%;\r\n    width: 150px;\r\n    height: 150px;\r\n    position: relative;\r\n\r\n    .locked-profile {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    .profile-locked-icon {\r\n        position: absolute;\r\n        height: 100%;\r\n        width: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        text-align: center;\r\n        line-height: 130px;\r\n        font-size: 70px;\r\n        border-radius: 50%;\r\n        border: 10px solid;\r\n        opacity: 0.8;\r\n\r\n        &.square-icon {\r\n            border-radius: 20px;\r\n        }\r\n    }\r\n\r\n    .profile-view-image {\r\n        width: 150px;\r\n        height: 150px;\r\n        text-align: center;\r\n        overflow: hidden;\r\n        display: inline-block;\r\n        position: relative;\r\n        font-weight: 400;\r\n        background: center center;\r\n        background-size: cover;\r\n        border-radius: 50%;\r\n\r\n        span {\r\n            display: block;\r\n        }\r\n\r\n        .profile-icon {\r\n            font-size: 150px;\r\n            margin-top: 0;\r\n            line-height: 1;\r\n            height: 100%;\r\n            overflow: hidden;\r\n\r\n            &.fi-icon-user-ico {\r\n                font-family: 'fontello';\r\n            }\r\n        }\r\n    }\r\n\r\n    &.fi-profile-view-image-square {\r\n        border-radius: 10px;\r\n\r\n        .profile-view-image {\r\n            border-radius: 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
